import React, { useState } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { ThemeProvider, useTheme } from './contexts/ThemeContext';
import { FontSizeProvider } from './contexts/FontSizeContext';
import { DesignProvider } from './contexts/DesignContext';
import 'styles/background.css';
import 'styles/variables.css';
import HeaderWithSegmentedControl from './components/HeaderWithSegmentedControl';
import Overview from './pages/Overview';
import Login from './pages/Login';

// Dashboard component that includes Header and content
const Dashboard: React.FC = () => {
  // Define navigation options for the segmented control
  const navigationOptions = [
    { id: 'overview', label: 'Overview', path: '/overview' },
    { id: 'jobs', label: 'Jobs', path: '/jobs' },
    { id: 'clusters', label: 'Clusters', path: '/clusters' },
  ];
  
  // Determine the active option based on the current URL path
  const path = window.location.pathname;
  let initialOption = 'overview';
  
  if (path.includes('/jobs')) {
    initialOption = 'jobs';
  } else if (path.includes('/clusters')) {
    initialOption = 'clusters';
  }
  
  // State to track the active navigation option
  const [activeOption, setActiveOption] = useState(initialOption);
  
  // Get theme context
  const { theme } = useTheme();
  const isDark = theme === 'dark';

  return (
    <div className={`${isDark ? "dashboard-container-dark" : "dashboard-container"} min-h-screen overflow-hidden flex flex-col`}>
      {/* Fixed header */}
      <div className="flex-shrink-0">
        <HeaderWithSegmentedControl
          title="Dashboard"
          options={navigationOptions}
          activeOptionId={activeOption}
          onOptionChange={setActiveOption}
        />
      </div>
      
      {/* Render the appropriate content based on the active option */}
      <div className="flex-grow pt-24"> {/* Add padding top to account for the fixed header */}
        {(activeOption === 'overview') && <Overview />}
        {(activeOption === 'jobs') && <div></div>}
        {(activeOption === 'clusters') && <div></div>}
      </div>
    </div>
  );
};

const App: React.FC = () => {
  return (
    <ThemeProvider>
      <FontSizeProvider>
        <DesignProvider>
          <Router>
            <Routes>
              <Route path="/login" element={<Login />} />
              <Route path="/overview" element={<Dashboard />} />
              <Route path="/jobs" element={<Dashboard />} />
              <Route path="/clusters" element={<Dashboard />} />
              <Route path="/" element={<Navigate replace to="/login" />} />
            </Routes>
          </Router>
        </DesignProvider>
      </FontSizeProvider>
    </ThemeProvider>
  );
};

export default App;
